import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { App } from './App';
import { CorporatePage } from './pages/CorporatePage';
import { InfluencersPage } from './pages/InfluencersPage';
import { PoliticiansPage } from './pages/PoliticiansPage';
import { BlueprintPage } from './pages/BlueprintPage';
import { KingdomCirclePage } from './pages/KingdomCirclePage';
import { SikhHeritageForwardPage } from './pages/SikhHeritageForwardPage';
import { LahoreTreasuryPage } from './pages/LahoreTreasuryPage';
import { TreasuryBlueprintPage } from './pages/TreasuryBlueprintPage';
import { SupportTheCourtPage } from './pages/SupportTheCourtPage';
import { SchoolsPage } from './pages/SchoolsPage';
import { SponsorABusPage } from './pages/SponsorABusPage';
import { HouseOfLionsPage } from './pages/HouseOfLionsPage';
import { AIEntrepreneurshipPage } from './pages/AIEntrepreneurshipPage';
import { SponsorDeckPage } from './pages/SponsorDeckPage';
import { RestorePunjabPage } from './pages/RestorePunjabPage';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function AppRouter() {
  return <BrowserRouter data-id="element-47">
      <ScrollToTop data-id="element-48" />
      <Routes data-id="element-49">
        <Route path="/" element={<App data-id="element-51" />} data-id="element-50" />
        <Route path="/corporate" element={<CorporatePage data-id="element-53" />} data-id="element-52" />
        <Route path="/influencers" element={<InfluencersPage data-id="element-55" />} data-id="element-54" />
        <Route path="/politicians" element={<PoliticiansPage data-id="element-57" />} data-id="element-56" />
        <Route path="/blueprint" element={<BlueprintPage data-id="element-59" />} data-id="element-58" />
        <Route path="/kingdom-circle" element={<KingdomCirclePage data-id="element-61" />} data-id="element-60" />
        <Route path="/sikh-heritage-forward" element={<SikhHeritageForwardPage data-id="element-63" />} data-id="element-62" />
        <Route path="/treasure" element={<LahoreTreasuryPage data-id="element-65" />} data-id="element-64" />
        <Route path="/treasure/blueprint" element={<TreasuryBlueprintPage data-id="element-67" />} data-id="element-66" />
        <Route path="/support-the-court" element={<SupportTheCourtPage data-id="element-69" />} data-id="element-68" />
        <Route path="/schools" element={<SchoolsPage data-id="element-71" />} data-id="element-70" />
        <Route path="/sponsor-a-bus" element={<SponsorABusPage data-id="element-73" />} data-id="element-72" />
        <Route path="/house-of-lions" element={<HouseOfLionsPage data-id="element-75" />} data-id="element-74" />
        <Route path="/ai-entrepreneurship" element={<AIEntrepreneurshipPage data-id="element-77" />} data-id="element-76" />
        <Route path="/sponsor-deck" element={<SponsorDeckPage data-id="element-79" />} data-id="element-78" />
        <Route path="/restore-punjab" element={<RestorePunjabPage data-id="element-81" />} data-id="element-80" />
      </Routes>
    </BrowserRouter>;
}